export default "__VITE_ASSET__a2741b1c__"